const Icon = ({ icon: TheIcon, ...restProps }) => {
    return <TheIcon {...restProps} />;
  };
  
  export default Icon;